// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphqlTag = require("graphql-tag").default;
var ReactHooks = require("@apollo/react-hooks");

function useSubscription(variables, client, skip, param) {
  var tmp = {};
  if (variables !== undefined) {
    tmp.variables = Caml_option.valFromOption(variables);
  }
  if (skip !== undefined) {
    tmp.skip = Caml_option.valFromOption(skip);
  }
  if (client !== undefined) {
    tmp.client = Caml_option.valFromOption(client);
  }
  var jsResult = ReactHooks.useSubscription(Curry._1(GraphqlTag, param[1]), tmp);
  var result_data = Belt_Option.map(Caml_option.nullable_to_opt(jsResult.data), param[0]);
  var result_loading = jsResult.loading;
  var result_error = Caml_option.nullable_to_opt(jsResult.error);
  var result = {
    data: result_data,
    loading: result_loading,
    error: result_error
  };
  var data = result_data;
  var tmp$1;
  if (data !== undefined) {
    tmp$1 = {
      TAG: "Data",
      _0: Caml_option.valFromOption(data)
    };
  } else {
    var error = result_error;
    tmp$1 = error !== undefined ? ({
          TAG: "Error",
          _0: Caml_option.valFromOption(error)
        }) : (
        result_loading ? "Loading" : "NoData"
      );
  }
  return [
          tmp$1,
          result
        ];
}

exports.useSubscription = useSubscription;
/* graphql-tag Not a pure module */
